import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setAppLanguage, SUPPORTED_LANGUAGES } from "@/i18n";
import { LegalFooter } from "@/components/LegalFooter";

export default function AuthShell({ title, subtitle, children }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || "en").split("-")[0];
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="px-6 py-5 max-w-6xl mx-auto w-full flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 w-fit">
          <img src="/jotbay-logo.png" alt="JotBay" className="h-9 w-auto" data-testid="auth-logo" />
        </Link>
        <div className="inline-flex rounded-full bg-slate-100 p-0.5" data-testid="auth-language-switcher">
          {SUPPORTED_LANGUAGES.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => setAppLanguage(l.code)}
              data-testid={`auth-lang-${l.code}`}
              className={`px-2.5 py-1 rounded-full text-xs font-semibold uppercase transition-colors ${
                current === l.code ? "bg-white text-navy shadow-sm" : "text-slatebody hover:text-navy"
              }`}
              title={l.native}
            >
              {l.code}
            </button>
          ))}
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-8">
        <div className="w-full max-w-md">
          <div className="rounded-xl border border-slate-200 bg-white p-8 shadow-sm animate-fade-up">
            <h1 className="font-display text-2xl font-bold text-navy">{title}</h1>
            {subtitle && <p className="text-sm text-slatebody mt-1.5 mb-6">{subtitle}</p>}
            <div className={subtitle ? "" : "mt-6"}>{children}</div>
          </div>
        </div>
      </div>
      <div className="px-6 pb-8"><LegalFooter /></div>
    </div>
  );
}
